


































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import User from "@/model/user";
import DeliveryDestinationList from "@/components/cutomer/deliveryDestination/deliveryDestinationList.vue";
import ChangePassword from "@/components/cutomer/mypage/changePassword.vue";
import userApi from "@/api/userApi";
import store from "@/store";

const authStore = namespace("Auth");
@Component({
  name: "CustomerInfo",
  components: {
    DeliveryDestinationList,
    ChangePassword,
  },
})
export default class CustomerInfo extends Vue {
  private isModal = false;
  @authStore.Getter
  getUserLogging!: User;

  showChangePasswordPopup() {
    (this.$refs.ChangePassword as ChangePassword).show();
  }

  public async logout() {
    try {
      const result = await userApi.logout();
      if (result.status === 200) {
        store.dispatch("Auth/logout");
      }
    } catch (error) {
      console.log(error);
    }
  }
}
